import { ZonedDateTime } from "@js-joda/core";
import { Table } from "react-bootstrap";
import type { InvoiceDto } from "shared";
import { useEventCallback } from "usehooks-ts";
import { SimpleTooltip } from "../common/SimpleTooltip";
import { TimeFormatter, useTime } from "../common/time/useTime";
import { ButtonIcon } from "../components/ButtonIcon";
import { useInvoices } from "./useSubscription";

export const InvoiceTable = () => {
	const { data: invoices } = useInvoices();
	const { format } = useTime();

	const handleDownload = useEventCallback((invoice: InvoiceDto) => {
		window.open(invoice.link, "_blank")?.focus();
	});

	return (
		<Table>
			<thead>
				<tr>
					<th>Number</th>
					<th>Date</th>
					<th>Amount</th>
					<th />
				</tr>
			</thead>
			<tbody>
				{invoices.map((x) => (
					<tr key={x.number}>
						<td>{x.number || "-"}</td>
						<td>{format(TimeFormatter.Date, ZonedDateTime.parse(x.date))}</td>
						<td>${(x.amount / 100).toFixed(2)}</td>
						<td>
							<div className="d-flex">
								{x.link && (
									<SimpleTooltip tooltip="View Invoice" placement="top">
										<ButtonIcon
											icon="file_copy"
											onClick={() => handleDownload(x)}
										/>
									</SimpleTooltip>
								)}
							</div>
						</td>
					</tr>
				))}
				{invoices.length === 0 && (
					<tr>
						<td colSpan={4} className="text-center text-muted">
							There are currently no invoices
						</td>
					</tr>
				)}
			</tbody>
		</Table>
	);
};
